module.exports = __webpack_public_path__ + "img/sa.2dd9486f.svg";